import type { CurrencyCodes } from '@onevesthq/ov-enums';
import { Selector } from '@ovComponents/2-component/selector/selector';
import { getCurrencyFlag } from '@utils/currency';

export const CalculatorResultCurrencySelector = ({
  availableCurrencies,
  resultCurrency,
  setResultCurrency,
}: {
  availableCurrencies: string[];
  resultCurrency: string;
  setResultCurrency: (currency: string) => void;
}) => {
  const options = availableCurrencies.map((currency) => ({
    label: currency,
    avatar: getCurrencyFlag(currency as CurrencyCodes),
    type: currency,
  }));

  return (
    <Selector
      testId='calculator-result-currency-selector'
      options={options}
      disabled={options.length <= 1}
      optionsPosition='right'
      selectedOptionType={resultCurrency}
      onChange={(event: { target: { value: string } }) =>
        setResultCurrency(event.target.value)
      }
      renderValue={(selected: string) => selected}
    />
  );
};
